(function () {
  'use strict';

  var SELECTORS = {
    slider: '[data-ethnec-slider]',
    slide: '[data-ethnec-slide]',
    dot: '[data-ethnec-slide-to]',
    countdown: '[data-ethnec-countdown]',
    countdownValue: '[data-ethnec-countdown-value]',
    countdownHours: '[data-ethnec-countdown-hours]',
    countdownMinutes: '[data-ethnec-countdown-minutes]',
    countdownSeconds: '[data-ethnec-countdown-seconds]',
    simulatedStock: '[data-ethnec-simulated-stock]',
    simulatedStockValue: '[data-ethnec-simulated-stock-value]',
    simulatedStockFill: '[data-ethnec-simulated-stock-fill]',
    viewers: '[data-ethnec-viewers]',
    viewersValue: '[data-ethnec-viewers-value]',
    collectionGrid: '.template-collection #CollectionAjaxContent .collection-grid__wrapper > .grid',
    collectionPagination: '.template-collection #CollectionAjaxContent .pagination',
    infiniteScroll: '[data-ethnec-infinite-scroll]'
  };

  var infiniteCollectionObserver;
  var infiniteCollectionRequestId = 0;

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function hash(input) {
    var value = 2166136261;
    var index;

    for (index = 0; index < input.length; index += 1) {
      value ^= input.charCodeAt(index);
      value = Math.imul(value, 16777619);
    }

    return value >>> 0;
  }

  function initSlider(slider) {
    if (slider.dataset.ethnecInitialized === 'true') {
      return;
    }

    var slides = Array.prototype.slice.call(slider.querySelectorAll(SELECTORS.slide));
    var dots = Array.prototype.slice.call(slider.querySelectorAll(SELECTORS.dot));
    var autoplay = slider.dataset.autoplay === 'true';
    var delay = Math.max(3000, Number(slider.dataset.autoplaySeconds || 7) * 1000);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer;

    if (slides.length < 2) {
      slider.dataset.ethnecInitialized = 'true';
      return;
    }

    function show(index, focusControl) {
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        if (focusControl && active) {
          dot.focus();
        }
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (autoplay && !reducedMotion && !document.hidden) {
        timer = window.setInterval(function () {
          show(current + 1, false);
        }, delay);
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(Number(dot.dataset.ethnecSlideTo || 0), false);
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    show(0, false);
    start();
    slider.dataset.ethnecInitialized = 'true';
  }

  function formatRemaining(milliseconds) {
    var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var clock = [hours, minutes, seconds].map(function (part) {
      return String(part).padStart(2, '0');
    }).join(':');

    return days > 0 ? days + 'd ' + clock : clock;
  }

  function initCountdown(element) {
    if (element.dataset.ethnecInitialized === 'true') {
      return;
    }

    var timestamp = Number(element.dataset.endsAt || 0) * 1000;
    var period = Number(element.dataset.recurring || 0) * 1000;
    var output = element.querySelector(SELECTORS.countdownValue);
    var hoursOutput = element.querySelector(SELECTORS.countdownHours);
    var minutesOutput = element.querySelector(SELECTORS.countdownMinutes);
    var secondsOutput = element.querySelector(SELECTORS.countdownSeconds);
    var timer;

    if (!timestamp || (!output && !hoursOutput)) {
      element.hidden = true;
      return;
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function renderTiles(milliseconds) {
      var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));

      hoursOutput.textContent = pad(Math.floor(totalSeconds / 3600));
      if (minutesOutput) {
        minutesOutput.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      }
      if (secondsOutput) {
        secondsOutput.textContent = pad(totalSeconds % 60);
      }
    }

    function update() {
      var remaining = timestamp - Date.now();

      if (remaining <= 0) {
        if (period <= 0) {
          element.hidden = true;
          if (timer) {
            window.clearInterval(timer);
          }
          return;
        }

        // Recurring windows roll forward instead of expiring, so a shopper
        // never lands on a countdown that has already run out.
        while (timestamp <= Date.now()) {
          timestamp += period;
        }
        remaining = timestamp - Date.now();
      }

      element.hidden = false;

      if (hoursOutput) {
        renderTiles(remaining);
      }

      if (output) {
        output.textContent = formatRemaining(remaining);
      }
    }

    update();
    timer = window.setInterval(update, 1000);
    element.dataset.ethnecInitialized = 'true';
  }

  function initSimulatedStock(element) {
    if (element.dataset.ethnecInitialized === 'true') {
      return;
    }

    var output = element.querySelector(SELECTORS.simulatedStockValue);
    var fill = element.querySelector(SELECTORS.simulatedStockFill);
    var productId = String(element.dataset.productId || 'product');
    var minimum = Math.max(1, Number(element.dataset.minimum || 3));
    var maximum = Math.max(minimum + 1, Number(element.dataset.maximum || 12));
    var period = Math.max(3600, Number(element.dataset.period || 86400)) * 1000;
    var resetsAt = Number(element.dataset.resetsAt || 0) * 1000;

    if (!output || !resetsAt) {
      element.hidden = true;
      return;
    }

    // Offsetting the ceiling by a stable per-product amount stops every product
    // on the site from advertising an identical number.
    var start = maximum - (hash(productId) % 3);
    if (start <= minimum) {
      start = minimum + 1;
    }

    function render() {
      var now = Date.now();
      var target = resetsAt;

      while (target <= now) {
        target += period;
      }

      var elapsed = 1 - ((target - now) / period);
      var value = Math.round(start - ((start - minimum) * elapsed));

      value = clamp(value, minimum, start);
      output.textContent = String(value);

      if (fill) {
        fill.style.width = Math.max(6, Math.round((value / start) * 100)) + '%';
      }
    }

    function updateAvailability(event) {
      var variant = event && event.detail ? event.detail.variant : null;
      if (variant) {
        element.hidden = !variant.available;
      }
    }

    var productSection = element.closest('.product-section');
    if (productSection) {
      productSection.addEventListener('variantChange', updateAvailability);
    }

    render();
    window.setInterval(render, 60000);
    element.dataset.ethnecInitialized = 'true';
  }

  function readViewerState(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }

  function writeViewerState(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // The counter remains stable in memory when session storage is unavailable.
    }
  }

  function initViewers(element) {
    if (element.dataset.ethnecInitialized === 'true') {
      return;
    }

    var output = element.querySelector(SELECTORS.viewersValue);
    var productId = String(element.dataset.productId || 'product');
    var minimum = Number(element.dataset.minimum || 18);
    var maximum = Math.max(minimum, Number(element.dataset.maximum || 82));
    var intervalSeconds = Math.max(15, Number(element.dataset.interval || 60));
    var intervalMs = intervalSeconds * 1000;
    var key = 'ethnec-simulated-viewers:' + productId;
    var stored = readViewerState(key);
    var bucket = Math.floor(Date.now() / intervalMs);
    var value = stored && Number.isFinite(stored.value)
      ? clamp(stored.value, minimum, maximum)
      : minimum + (hash(productId + ':' + bucket) % (maximum - minimum + 1));
    var productSection = element.closest('.product-section');

    if (!output) {
      return;
    }

    function render() {
      output.textContent = String(value);
      writeViewerState(key, { value: value, bucket: bucket });
    }

    function move() {
      bucket = Math.floor(Date.now() / intervalMs);
      var movementOptions = [-3, -2, -1, 1, 2, 3];
      var movement = movementOptions[hash(productId + ':' + bucket) % movementOptions.length];
      value = clamp(value + movement, minimum, maximum);
      render();
    }

    function updateAvailability(event) {
      var variant = event && event.detail ? event.detail.variant : null;
      if (variant) {
        element.hidden = !variant.available;
      }
    }

    render();
    window.setInterval(move, intervalMs);
    if (productSection) {
      productSection.addEventListener('variantChange', updateAvailability);
    }
    element.dataset.ethnecInitialized = 'true';
  }

  function prepareInfiniteCard(card) {
    // The theme keeps .image-element at opacity 0 until AOS adds `aos-animate`
    // to a [data-aos] ancestor. Appended cards never pass through AOS, so
    // stripping data-aos below would otherwise leave every image loaded but
    // permanently invisible. This class restores them.
    card.classList.add('ethnec-infinite-card');

    if (card.hasAttribute('data-aos')) {
      card.removeAttribute('data-aos');
    }

    card.querySelectorAll('[data-aos]').forEach(function (element) {
      element.removeAttribute('data-aos');
      element.classList.remove('aos-init', 'aos-animate');
    });

    return card;
  }

  function initInfiniteCollection() {
    var grid = document.querySelector(SELECTORS.collectionGrid);
    var pagination = document.querySelector(SELECTORS.collectionPagination);
    var nextLink;
    var sentinel;
    var nextUrl;
    var loading = false;
    var requestId;

    if (infiniteCollectionObserver) {
      infiniteCollectionObserver.disconnect();
      infiniteCollectionObserver = null;
    }

    document.querySelectorAll(SELECTORS.infiniteScroll).forEach(function (element) {
      element.remove();
    });

    if (!grid || !pagination || !('IntersectionObserver' in window) || !window.fetch) {
      return;
    }

    nextLink = pagination.querySelector('.next a');
    if (!nextLink) {
      return;
    }

    pagination.classList.add('ethnec-pagination--enhanced');
    nextUrl = nextLink.href;
    requestId = ++infiniteCollectionRequestId;

    sentinel = document.createElement('div');
    sentinel.className = 'ethnec-infinite-scroll';
    sentinel.setAttribute('data-ethnec-infinite-scroll', '');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.innerHTML = '<span class="ethnec-infinite-scroll__status"><span class="ethnec-infinite-scroll__spinner" aria-hidden="true"></span>Loading more products</span>';
    pagination.parentNode.insertBefore(sentinel, pagination);

    function revealPaginationFallback() {
      sentinel.hidden = true;
      pagination.classList.remove('ethnec-pagination--enhanced');
      if (infiniteCollectionObserver) {
        infiniteCollectionObserver.disconnect();
        infiniteCollectionObserver = null;
      }
    }

    function finish() {
      sentinel.classList.remove('is-loading');
      loading = false;

      // The observer only reports intersection *changes*. When an appended page
      // leaves the sentinel still inside the root margin its state never
      // transitions, so nothing would trigger the next page and a shopper
      // already at the bottom has no way to scroll further to unstick it.
      window.setTimeout(maybeLoadMore, 60);
    }

    function maybeLoadMore() {
      if (loading || !nextUrl || sentinel.hidden) {
        return;
      }

      if (sentinel.getBoundingClientRect().top < window.innerHeight + 700) {
        loadNextPage();
      }
    }

    function loadNextPage() {
      if (loading || !nextUrl) {
        return;
      }

      loading = true;
      sentinel.classList.add('is-loading');

      window.fetch(nextUrl, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to load the next collection page.');
          }
          return response.text();
        })
        .then(function (markup) {
          var nextDocument;
          var nextGrid;
          var nextPagination;
          var followingLink;
          var fragment;
          var appendedCount = 0;

          if (requestId !== infiniteCollectionRequestId || !document.body.contains(grid)) {
            return;
          }

          nextDocument = new DOMParser().parseFromString(markup, 'text/html');
          nextGrid = nextDocument.querySelector('#CollectionAjaxContent .collection-grid__wrapper > .grid');
          nextPagination = nextDocument.querySelector('#CollectionAjaxContent .pagination');

          if (!nextGrid) {
            throw new Error('The next collection page did not contain a product grid.');
          }

          fragment = document.createDocumentFragment();
          Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
            fragment.appendChild(prepareInfiniteCard(card));
            appendedCount += 1;
          });
          grid.appendChild(fragment);

          if (nextPagination) {
            pagination.innerHTML = nextPagination.innerHTML;
            followingLink = pagination.querySelector('.next a');
          }

          nextUrl = followingLink ? followingLink.href : '';

          if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
            window.theme.reinitProductGridItem();
          }

          document.dispatchEvent(new CustomEvent('collection:infinite:loaded', {
            detail: {
              count: appendedCount,
              nextUrl: nextUrl
            }
          }));

          if (!nextUrl) {
            sentinel.hidden = true;
            if (infiniteCollectionObserver) {
              infiniteCollectionObserver.disconnect();
              infiniteCollectionObserver = null;
            }
          }
        })
        .then(finish)
        .catch(function () {
          finish();
          revealPaginationFallback();
        });
    }

    infiniteCollectionObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        loadNextPage();
      }
    }, {
      rootMargin: '700px 0px'
    });

    infiniteCollectionObserver.observe(sentinel);

    // Backstop for the same reason: a fast flick can carry the sentinel past
    // the margin between observer callbacks.
    window.addEventListener('scroll', maybeLoadMore, { passive: true });
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll(SELECTORS.slider).forEach(initSlider);
    scope.querySelectorAll(SELECTORS.countdown).forEach(initCountdown);
    scope.querySelectorAll(SELECTORS.simulatedStock).forEach(initSimulatedStock);
    scope.querySelectorAll(SELECTORS.viewers).forEach(initViewers);

    if (scope === document || scope.querySelector(SELECTORS.collectionGrid)) {
      initInfiniteCollection();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('quickview:loaded', function () {
    init(document);
  });
  document.addEventListener('collection:reloaded', function () {
    initInfiniteCollection();
  });
}());
